import React, { Component } from 'react';
import {
  Table,
  Input,
  Header,
  Segment,
  Container,
  Icon,
  Pagination,
  Button,
  Dimmer,
  Loader,
  Popup,
  Modal
} from 'semantic-ui-react';

import {
  makeGetWithParam,
  makeDelete,
  makePut
} from './../../../../src/services/ServiceManager';

export default class TagManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isSearching: false,
      tagNameBeingChanged: false,
      deletingTagId: -1,
      searchTimeoutId: null,
      activePage: 1,
      totalPages: 0,
      rowsPerPage: 10,
      tags: [],
      tagIdBeingEdited: -1,
      tagName: '', // just tag name for now.,
      error: false,
      temporaryTagName: null,
      warning: null
    };
  }

  componentDidMount() {
    const { saveGTMEvent, setSectionTitle } = this.props;

    if (saveGTMEvent) saveGTMEvent('Tag Manager', 'Tag Manager');
    if (setSectionTitle) setSectionTitle('Tag Manager');

    this.fetch();
  }

  onSearchChange = (event, { value }) => {
    const { searchTimeoutId } = this.state;

    clearTimeout(searchTimeoutId);

    this.setState(
      {
        ...this.state,
        isSearching: true,
        tagName: value
      },
      this.search(value)
    );
  };

  search = () => () => {
    const nextTimeoutId = setTimeout(() => {
      const { tagName } = this.state;
      const query =
        tagName && tagName.trim() !== '' ? `tagName=${tagName}` : '';

      this.fetch(query);
    }, 1000);

    this.setState((prevState) => ({
      ...prevState,
      searchTimeoutId: nextTimeoutId
    }));
  };

  fetch = (query = '') => {
    this.setState(
      {
        ...this.state,
        isLoading: true
      },
      () => {
        const { activePage, rowsPerPage } = this.state;
        makeGetWithParam(
          'service/tags/list',
          null,
          `?activePage=${activePage}&rowsPerPage=${rowsPerPage}&${query}`
        ).then((response) => {
          const { result, statusCode } = response;
          const { tags, activePage: returnedActivePage, totalPages } =
            result || {};

          if (statusCode === 200) {
            this.setState((prevState) => ({
              ...prevState,
              tags,
              activePage: returnedActivePage,
              totalPages,
              isLoading: false,
              isSearching: false
            }));
          } else {
            this.setState((prevState) => ({
              ...prevState,
              tags,
              activePage: 1,
              totalPages: 1,
              isLoading: false,
              isSearching: false
            }));
          }
        });
      }
    );
  };

  onEditTag = (event, { tagId }) => {
    this.setState((prevState) => ({
      ...prevState,
      tagIdBeingEdited: tagId
    }));
  };

  onTagNameChange = (event, { value }) => {
    this.setState((prevState) => ({
      ...prevState,
      temporaryTagName: value
    }));
  };

  onEditTagCancel = () => {
    this.setState((prevState) => ({
      ...prevState,
      tagIdBeingEdited: -1,
      temporaryTagName: null
    }));
  };

  onEditTagConfirm = () => {
    this.setState(
      {
        ...this.state,
        tagNameBeingChanged: true
      },
      () => {
        const { tagIdBeingEdited, temporaryTagName } = this.state;

        makePut('service/tags/name', {
          tagId: tagIdBeingEdited,
          name: temporaryTagName
        }).then((response) => {
          const { statusCode } = response;

          if (statusCode === 200) {
            const { tags } = this.state;

            const newTags = tags.map((tag) => {
              const { id } = tag;

              if (id === tagIdBeingEdited) {
                return {
                  ...tag,
                  value: temporaryTagName
                };
              }

              return tag;
            });

            this.setState((prevState) => ({
              ...prevState,
              tagIdBeingEdited: -1,
              temporaryTagName: null,
              tagNameBeingChanged: false,
              tags: newTags
            }));
          } else {
            this.setState((prevState) => ({
              ...prevState,
              tagIdBeingEdited: -1,
              temporaryTagName: null,
              tagNameBeingChanged: false,
              error: true
            }));
          }
        });
      }
    );
  };

  onDeleteTag = (event, { tagId }) => {
    // validate if it is ok to delete. Check if the tag is belong to at least one asset.
    const { tags } = this.state;
    const tag = tags.find((tmpTag) => tmpTag.id === tagId);

    if (!tag) throw new Error('Tag cannot be found.');

    const { assetNumber } = tag;

    if (assetNumber > 0) {
      this.setState((prevState) => ({
        ...prevState,
        deletingTagId: tagId,
        warning: {
          title: 'The tag has dependencies.',
          message: `The tag is associated with ${assetNumber} number of assets. Do you still want to delete this tag?`
        }
      }));

      return;
    }

    this.deleteTag(tagId);
  };

  deleteTag = (tagId) => {
    makeDelete('service/tags', { tagId }, null).then((response) => {
      const { statusCode } = response;

      if (statusCode !== 200) return;

      this.setState(
        {
          ...this.state,
          deletingTagId: -1
        },
        () => {
          const { tagName } = this.state;

          const query = `tagName=${tagName}`;

          this.fetch(query);
        }
      );
    });
  };

  onPageChange = (event, { activePage }) => {
    this.setState(
      {
        ...this.state,
        activePage
      },
      () => {
        this.fetch();
      }
    );
  };

  onModalClose = () => {
    this.setState((prevState) => ({
      ...prevState,
      warning: null,
      deletingTagId: -1
    }));
  };

  onModalProceed = () => {
    const { deletingTagId } = this.state;

    this.setState(
      {
        ...this.state,
        warning: null
      },
      () => {
        this.deleteTag(deletingTagId);
      }
    );
  };

  render() {
    const {
      isLoading,
      isSearching,
      tagNameBeingChanged,
      tags,
      activePage,
      totalPages,
      tagIdBeingEdited,
      deletingTagId,
      error,
      temporaryTagName,
      warning
    } = this.state;
    return (
      <Container fluid>
        <Dimmer active={isLoading} inverted>
          <Loader inverted>Loading...</Loader>
        </Dimmer>

        <Segment>
          <Input
            icon="search"
            placeholder="Search"
            loading={isSearching}
            onChange={this.onSearchChange}
          />

          {(!tags || error) && (
            <Segment fluid>
              <Header
                as="h2"
                icon
                style={{
                  transform: 'translateX(-50%)',
                  position: 'relative',
                  left: '50%'
                }}
              >
                <Icon name="exclamation" />
                Oops! Something went wrong.
                <Header.Subheader>Please try again later.</Header.Subheader>
              </Header>
            </Segment>
          )}

          {tags && tags.length > 0 && !error && (
            <div style={{ marginTop: '2em' }}>
              <Table singleLine selectable striped>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell />
                    <Table.HeaderCell textAlign="center">
                      Category
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      # of Assets
                    </Table.HeaderCell>
                    <Table.HeaderCell />
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {tags
                    ? tags.map((tag) => {
                        const { value, category } = tag;
                        return (
                          <Table.Row
                            key={`tag_row_${tag.id}`}
                            warning={tag.assetNumber === 0}
                            active={tag.id === tagIdBeingEdited}
                          >
                            <Table.Cell width={4}>
                              {tag.assetNumber === 0 && (
                                <Popup
                                  trigger={<Icon name="attention" />}
                                  content="This tag does not belong to any assets."
                                />
                              )}
                              <Input
                                tagId={tag.id}
                                transparent={tag.id !== tagIdBeingEdited}
                                value={
                                  tagIdBeingEdited === tag.id &&
                                  temporaryTagName
                                    ? temporaryTagName
                                    : value
                                }
                                style={{
                                  color: 'rgba(0,0,0,.87)',
                                  opacity: 1
                                }}
                                disabled={tag.id !== tagIdBeingEdited}
                                onChange={this.onTagNameChange}
                              />
                            </Table.Cell>
                            <Table.Cell width={2}>
                              <Button.Group
                                basic
                                size="mini"
                                style={{ marginLeft: '0.5em' }}
                              >
                                {tag.id === tagIdBeingEdited && (
                                  <div>
                                    <Button
                                      icon="check"
                                      loading={tagNameBeingChanged}
                                      onClick={this.onEditTagConfirm}
                                    />
                                    <Button
                                      icon="cancel"
                                      disabled={tagNameBeingChanged} // disabled if tag name is being changed and wait untill it finishes
                                      onClick={this.onEditTagCancel}
                                    />
                                  </div>
                                )}

                                {tag.id !== tagIdBeingEdited && (
                                  <Button
                                    icon="pencil"
                                    tagId={tag.id}
                                    disabled={
                                      tag.id !== tagIdBeingEdited &&
                                      tagNameBeingChanged
                                    }
                                    onClick={this.onEditTag}
                                  />
                                )}
                              </Button.Group>
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {category}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {tag.assetNumber}
                            </Table.Cell>
                            <Table.Cell width={2} textAlign="center">
                              <Button
                                negative
                                tagId={tag.id}
                                onClick={this.onDeleteTag}
                                disabled={tagNameBeingChanged}
                                loading={tag.id === deletingTagId}
                              >
                                Delete
                              </Button>
                            </Table.Cell>
                          </Table.Row>
                        );
                      })
                    : null}
                </Table.Body>
              </Table>

              <Container fluid textAlign="center">
                <Pagination
                  defaultActivePage={activePage}
                  totalPages={totalPages}
                  onPageChange={this.onPageChange}
                />
              </Container>
            </div>
          )}
        </Segment>

        <Modal size="tiny" open={warning} onClose={this.onModalClose}>
          <Modal.Header>{warning ? warning.title : null}</Modal.Header>
          <Modal.Content>{warning ? warning.message : null}</Modal.Content>
          <Modal.Actions>
            <Button negative onClick={this.onModalClose}>
              No
            </Button>
            <Button positive onClick={this.onModalProceed}>
              Proceed
            </Button>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/TagManager/TagManager.jsx